import initializeJQueryElements from './initialize-jquery-ui-elements'
import makeExportAddListSticky from './make-export-add-list-sticky'

export default function () {
  const unsubscriber = initializeJQueryElements()
  makeExportAddListSticky()

  return unsubscriber
}
